<template>
  <v-container fluid grid-list-lg>
      <ShorttermBanner></ShorttermBanner>
      <ShorttermRequirements class="mt-12"></ShorttermRequirements>
      <ShorttermPriceTable></ShorttermPriceTable>
  </v-container>
</template>
<script>
import ShorttermBanner from "../components/ui/ShorttermBanner.vue";
import ShorttermRequirements from "../components/ui/ShorttermRequirements.vue";
import ShorttermPriceTable from "../components/ui/ShorttermPriceTable.vue";
export default {
    name: "Shortterm",
    components: {
      ShorttermBanner,
      ShorttermRequirements,
      ShorttermPriceTable
    },
    data: () => ({

    }),
    methods: {
        sendToNewLink: function (url) {
            window.location.href = url;
        }
    }
};
</script>
<style scoped>
</style>
